const serviceBtns = document.querySelectorAll("[data-role='service-btn']");

serviceBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    // Define value of btn
    const btnValue = btn.getAttribute("data-value");

    // Set all buttons gray color
    serviceBtns.forEach((item) => {
      item.classList.remove("bg-skb");
      item.classList.remove("text-white");
      item.classList.add("bg-lightGray");
    });

    // set blue color to clicked button
    btn.classList.add("bg-skb");
    btn.classList.add("text-white");

    document
      .querySelectorAll("[data-role='grid-hover-item']")
      .forEach((item) => {
        if (item.getAttribute("data-value") == btnValue) {
          item.classList.remove("hidden");
        } else if (btnValue == "all") {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
  });
});
